import { defineStore } from 'pinia'

export const useUserStore=defineStore('user',{
    state:()=>({
        token: localStorage.getItem('token') || '',
        tokenExpiry: localStorage.getItem('tokenExpiry') || '',
        userInfo: {
            zsname: localStorage.getItem('zsname') || '',
            phone: localStorage.getItem('phone') || '',
            id:localStorage.getItem('id') || '',
            nickname: localStorage.getItem('nickname') || '',
            create_time: localStorage.getItem('create_time') || ''

        },
    }),
    getters: {
        isLoggedIn: (state) => {
            if (!state.token) return false;
            // 检查token是否过期（3小时 = 3 * 60 * 60 * 1000 毫秒）
            const now = Date.now();
            const expiryTime = parseInt(state.tokenExpiry) || 0;
            return now < expiryTime;
        },
    },
    actions:{
        setToken(token) {
            this.token = token
            // 设置token过期时间为3小时后
            const expiryTime = Date.now() + (3 * 60 * 60 * 1000); // 3小时
            this.tokenExpiry = expiryTime.toString()
            localStorage.setItem('token', token)
            localStorage.setItem('tokenExpiry', expiryTime.toString())
        },
        clearToken() {
            this.token = ''
            this.tokenExpiry = ''
            this.userInfo = {
                zsname: '',
                phone: '',
                id:'',
                nickname:'',
                create_time:''

            }
            localStorage.removeItem('token')
            localStorage.removeItem('tokenExpiry')
            localStorage.removeItem('zsname')
            localStorage.removeItem('phone')
            localStorage.removeItem('id')
            localStorage.removeItem('nickname')
            localStorage.removeItem('create_time')
        },
        setUserInfo(info) {
            this.userInfo = info
            localStorage.setItem('zsname', info.zsname || '')
            localStorage.setItem('phone', info.phone || '')
            localStorage.setItem('id', info.id || '')
            localStorage.setItem('nickname', info.nickname || '')
            localStorage.setItem('create_time', info.create_time || '')
        },
        // 检查并清除过期的token
        checkTokenExpiry() {
            if (!this.token) return;
            const now = Date.now();
            const expiryTime = parseInt(this.tokenExpiry) || 0;
            if (now >= expiryTime) {
                this.clearToken();
                return true; // 返回true表示token已过期并被清除
            }
            return false; // 返回false表示token仍然有效
        }
    }
})